import React, { useEffect } from 'react'
import CONSTANTS from '../../Constants';
import Input from '../Forms/Input';
import { useState } from 'react';
import './VinPopIn.scss'
import { Select, Button } from '../Forms/Forms';
import fetchApiData from '../../apiHandlers/fetchApiData';
import { setVeiculeInfos, setMileageStep, setSelectedMileageStep } from '../../redux-files/actions/action';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from '../../helpers/helpers';
import { useRef } from 'react';
import { pushEventToGTM } from '../../helpers/trackerManager';


const VinPopIn = ({ handleClose, onSave, handleClickOutside = () => { }, onLoadPas, isSecondeStapeDisabled, options }) => {
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const [serieNumberInput, setSerieNumberInput] = useState(vehicleInfo.SerialNumber)
    const [serieNumberErrorLabel, setSerieNumberErrorLabel] = useState('')
    const [selectedPasKilometrique, setSelectedPasKilometrique] = useState({ key: '', value: options.key })
    const [isButtonDisabled, setIsButtonDisabled] = useState(true)
    const myRef = useRef()
    const dispatch = useDispatch()
    useEffect(() => {
        if (vehicleInfo.SerialNumber.length > 0) {
            onLoadPas()
        }
        // Bind the event listener
        document.addEventListener("mousedown", (e) => handleClickOutside(e, myRef));
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", (e) => handleClickOutside(e, myRef));
        };
    }, [])
    const checkSerieNumber = () => {
        const seriNumberAPI = new fetchApiData()
        seriNumberAPI.getSerieNumber(serieNumberInput)
            .then(
                data => {
                    switch (data.d.ErrorCode) {
                        case 0:
                            // if (this.isRecallCampagneActivate && this.props.store.car.SerialNumber !== undefined && !this.props.store.car.SerialNumber.length) this.checkCampRapEligibility(this.state.serieInput);
                            dispatch(setVeiculeInfos({ ...data.d.VehicleInfo, 'Mileage': vehicleInfo.Mileage, 'contratService': vehicleInfo.contratService }));
                            setSerieNumberErrorLabel('')
                            onLoadPas(serieNumberInput);
                            break;
                        default:
                            setSerieNumberErrorLabel(data.d.ErrorMessage)
                            break;
                    }
                })
            .catch(Error => {
                console.error('fait: ', Error)
                setSerieNumberErrorLabel('error')
                // setIsLoading(false)
            })
            pushEventToGTM({
                pageName: 'services - révision - popin VIN',
                eventAction: 'Display::Popin::VIN',
                eventLabel: CONSTANTS.LABELS.needs_quote_vin_check,
                eventCategory: 'content'
            })
    };

    return (
        <>
            <div ref={myRef} className='vin-Popin-container'>
                {isMobile() && <div className='vehicle-info'>
                    {CONSTANTS.LABELS.needs_quote_vehicle}
                </div>}
                <p className='text-info'>{CONSTANTS.LABELS.needs_basket_maintenance_label1}</p>
                <span className='close' onClick={handleClose}></span>

                <Input
                    label={CONSTANTS.LABELS.needs_quote_vin}
                    placeholder={CONSTANTS.LABELS.needs_basket_maintenance_label3}
                    isAutoFocus={true}
                    onChange={(e) => {
                        setSerieNumberInput(e.target.value)
                    }}
                    errorLabel={serieNumberErrorLabel}
                    Value={serieNumberInput}
                >

                    <Button
                        handlClick={checkSerieNumber}
                        isDisabled={serieNumberInput.length < 1}
                    >
                        {CONSTANTS.LABELS.needs_quote_vin_check}
                    </Button>
                    {!isMobile() && <i className='info-icon'></i>}

                </Input>
                {isMobile() && <div className='vin-info info-icon'>{CONSTANTS.LABELS.needs_basket_maintenance_help1}</div>}
                <Select
                    label={CONSTANTS.LABELS.needs_basket_maintenance_label4}
                    Options={options}
                    Selected={selectedPasKilometrique.key}
                    Name="mileage-Step"
                    isDisabled={isSecondeStapeDisabled}
                    onChange={(e) => {
                        setSelectedPasKilometrique({ 'key': e.target.value, 'value': options[e.target.value] })
                        dispatch(setSelectedMileageStep({ 'key': e.target.value, 'value': options[e.target.value] }))
                        e.target.value.length > 1 ? setIsButtonDisabled(false) : setIsButtonDisabled(true)
                    }
                    }
                />
                <Button
                    handlClick={() => onSave({ 'key': selectedPasKilometrique.key, 'value': options[selectedPasKilometrique.key] })}
                    isDisabled={isButtonDisabled}
                >
                    {isMobile() ? CONSTANTS.LABELS.common_v2_continue : CONSTANTS.LABELS.needs_quote_vin_save}
                </Button>

            </div>
        </>
    );
}
export default VinPopIn;